import { objectToCamelCase } from '../utils'
import options, { permissionNames } from './options'

export default class AdminPermissions {
  static options = options
  static permissionNames = permissionNames
  constructor(adminPermissions) {
    const {
      id = '',
      name = '',
      viewWhichRequests = '',
      editWhichRequests = '',
      canViewMessages = '',
      canViewEmployees = '',
      canViewReports = '',
      canViewEmployeeCodes = '',
      canEditEmployeeCodes = '',
    } = adminPermissions
    Object.assign(this, {
      id,
      name,
      viewWhichRequests,
      editWhichRequests,
      canViewMessages,
      canViewEmployees,
      canViewReports,
      canViewEmployeeCodes,
      canEditEmployeeCodes,
    })
  }

  static create(opts) {
    return new AdminPermissions(opts)
  }

  static fromAPI(json = {}) {
    return new AdminPermissions(objectToCamelCase(json))
  }
}
